module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon06-921a84a28cc54a0ff71903c907fe9704.png";